export default {
  diasAtrasoProdutoCard: {
    value: null,
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/board/modal/block-ajuizamento/ModalBlockAjuizamento-form.js